import {dict} from '@tubo/tubo-base'
import util from './util'
import Vue from 'vue'
import iView from 'iview'
import {PhotoPreview, ImageView} from '@/components/libs'

Vue.component('PhotoPreviewDirective', PhotoPreview)
Vue.component('ImageView', ImageView)


const directive = {
  preview(el, binding) {
    el.onclick = () => {
      if (binding.value) {
        const ref = util.uuid()
        iView.Spin.show({
          render: (h) => {
            return h('PhotoPreviewDirective', {
              props: {item: binding.value.item, list: binding.value.list}
            })
          }
        })
      }
    }
  },
  dict(el, binding) {
    if (binding.value && binding.arg) {
      dict.dict(binding.arg).then(res => {
        el.innerHTML = res.content[binding.value] || '--'
      })
    } else {
      el.innerHTML = '--'
    }
  },
  dist6nameZh(el, binding) {
    if (binding.value) {
      dict.dist6nameZh(binding.value).then(res => {
        el.innerHTML = res
      })
    } else {
      el.innerHTML = '--'
    }
  }
}

export default {
  dict: {
    bind: directive.dict,
    update: directive.dict
  },
  dist6nameZh: {
    bind: directive.dist6nameZh,
    update: directive.dist6nameZh
  },
  'image-preview': {
    update: directive.preview,
    bind: directive.preview
  }
}